export default __webpack_public_path__ + "static/pie-chart-f5426cb0a0e6c9ce6c3df427c433d4d0.svg";